import React from 'react';
import useProps from '../_util/useProps';
import { useEffect } from 'react';
import LineFlowLayer from './LineFlowLayer';
import { registerEventLayer } from '../events';

export default function(props) {
    const { map, groupLayer } = useProps();
    const { data, isToBottom } = props;
    useEffect(() => {
        const primitive = new LineFlowLayer({ ...props, map });
        // 注册事件
        registerEventLayer(primitive, props);
        if (groupLayer) {
            groupLayer.addLayer(primitive);
        } else {
            map.addLayer(primitive);
        }
        if (isToBottom) {
            map.scene.primitives.lowerToBottom(primitive);
        }
        if (map?.highlightLayer?.primitiveLayer) {
            map.scene.primitives.raiseToTop(map.highlightLayer.primitiveLayer);
        }
        return () => {
            map.removeLayer(primitive);
        };
    }, [data]);
    return <></>;
}
